<template>
  <div class="result">
    <div class="container">
      <img
        class="bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e8c98e00099ee5d7823b2d86ed2dba44.png"
        alt=""
      />
      <div v-if="info">
        <div class="c-item top">
          <div class="user-info">
            <div class="avatar" v-if="info.head_img">
              <img class="avatar-image" :src="info.head_img" alt="" />
            </div>
            <div class="nickname">{{
              info.truename || info.nickname || ''
            }}</div>
          </div>
          <div class="desc"
            >本问卷基于专业医学、内分泌学专业知识搭建，旨在通过科学分析，帮助您分析身材类型，更有针对性的进行身材管理</div
          >
          <div class="type-content">
            <div class="type-left">
              <div class="type-desc">亲爱的学员<br />通过测试您属于：</div>
              <div class="type-text">
                <div>{{ info.body_title }}身材</div>
                <div class="line"></div>
              </div>
            </div>
            <img
              class="type-image"
              :src="info[gender[info.gender || '2']]"
              alt=""
            />
          </div>
          <!-- 营养师说 -->
          <div class="dietitian-content">
            <img
              class="d-dot"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8cfb7f9455824db84b164a259d6047eb.png"
              alt=""
            />
            <div class="d-info">
              <img
                class="d-avatar"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/21cb47f0dcd2cfde1de8b5a5e0eab0d8.png"
                alt=""
              />
              <div class="d-right">
                <div class="d-name">营养师李玲</div>
                <div class="d-tag-list">
                  <div class="d-tag-item">高级营养师</div>
                  <div class="d-tag-item">国家健康管理师</div>
                </div>
              </div>
            </div>
            <div class="d-text" v-html="info.physical_profile"></div>
          </div>
        </div>
        <div class="c-item influence">
          <div class="c-title">
            <img
              class="title-icon"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5935131cca434d031746544c886e8fae.png"
              alt=""
            />
            <div class="title-text">产生原因</div>
          </div>
          <div class="desc" v-html="info.influence"></div>
        </div>
        <div class="c-item performance">
          <div class="c-title">
            <img
              class="title-icon"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a45296ef3369b06b6ae7d12d85107ef8.png"
              alt=""
            />
            <div class="title-text">常见潜在表现</div>
          </div>
          <div class="list">
            <div
              class="item"
              v-for="(item, index) in info.performance"
              :key="index"
            >
              <span class="item-bold">{{ index + 1 }}、{{ item.title }} </span>
              <span>{{ item.text }}</span>
            </div>
          </div>
        </div>
        <div class="c-item suggest">
          <div class="c-title">
            <img
              class="title-icon"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a70b0f70e853d705db42015b319e098d.png"
              alt=""
            />
            <div class="title-text">贴心建议</div>
          </div>
          <div class="gray-content">
            <div class="gray-item">
              <div class="gray-title">生活饮食建议</div>
              <div class="suggest-list">
                <div
                  class="suggest-item"
                  v-for="(item, index) in info.dietary_advice"
                  :key="index"
                >
                  {{ index + 1 }}、{{ item }}
                </div>
              </div>
            </div>
            <div class="gray-item">
              <div class="gray-title">需补充的营养素</div>
              <div class="ele-list">
                <div
                  class="ele-item"
                  v-for="(item, index) in info.nutrients"
                  :key="index"
                >
                  <div class="item-title"
                    ><span class="item-num">{{ index + 1 }}</span
                    >{{ item.el }}
                  </div>
                  <span></span><span>{{ item.text }}</span>
                </div>
              </div>
            </div>
            <div class="gray-item">
              <div class="gray-title">减少摄入</div>
              <div class="suggest-list">
                <div
                  class="suggest-item"
                  v-for="(item, index) in info.reduce_intake"
                  :key="index"
                  ><span class="item-bold"
                    >{{ index + 1 }}、{{ item.title }} </span
                  >{{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="c-item coach-recommend" v-if="info.first_choose || info.combination">
          <div class="c-title">
            <img
              class="title-icon"
              src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/fc65986aa51892a6edfe1f9c419a2ca7_wh=52_52.png"
              alt=""
            />
            <div class="title-text">营养师严选</div>
          </div>
          <div class="goods-list">
            <div class="goods-item" v-if="info.first_choose">
              <img
                @click="bindHandleGoods"
                class="goods-image"
                :src="info.first_choose.image"
                alt=""
              />
            </div>
            <div class="goods-item" v-if="info.combination">
              <img
                @click="bindHandleGoodsGroup"
                class="goods-image"
                :src="info.combination.image"
                alt=""
              />
            </div>
          </div>
        </div> -->
        <div class="c-item course-container">
          <div class="course-box">
            <div class="course-content">
              <img
                class="dot"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f29d97a36d51bdf43b4b05737d02c77c.png"
                alt=""
              />
              <div class="c-flex">
                <div class="c-flex-left"
                  >现在，我们相信您已经<br />大致了解自己的体型的饮食注意事项</div
                >
                <img
                  class="c-avatar"
                  src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/21cb47f0dcd2cfde1de8b5a5e0eab0d8.png"
                  alt=""
                />
              </div>
              <div class="c-desc">针对体型，请重点关注以下课程内容</div>
            </div>
          </div>
          <div class="camp-list">
            <div
              class="camp-item"
              v-for="(item, index) in info.recommend_content"
              :key="index"
            >
              <div class="camp-title">{{ item.title }}</div>
              <div class="camp-text">{{ item.text }}</div>
            </div>
          </div>
          <div class="my-course" @click="bindMyCourse">
            <img
              class="icon"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0cec1237411857d7ea5bbf350efd73e2.png"
              alt=""
            />
            <div class="text">我的课程</div>
            <div class="iconfont icon-you"></div>
          </div>
          <div class="desc"
            >接下来，我们会根据您的体型，<br />用专业、科学的解决方案，帮助您健康减重，一瘦到底！</div
          >
        </div>
        <div class="c-item literature" v-if="info.reference.length">
          <div class="literature-item">参考文献：</div>
          <div
            class="literature-item"
            v-for="(item, index) in info.reference"
            :key="index"
            >{{ item }}</div
          >
        </div>
        <img
          class="logo"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getShareUrl, getShareData } from '../../common.js'
import appApi from '@/common/app-common.js'
export default {
  data() {
    return {
      info: null,
      gender: {
        1: 'man_body_icon',
        2: 'woman_body_icon'
      }
    }
  },
  created() {
    this.getResult()
  },
  methods: {
    getResult() {
      let params = {
        que_user_id: this.$route.query.que_id,
        que_id: this.$route.query.que_type,
        admin_uid: this.$route.query.admin_uid
      }
      this.$http
        .getBaseAppWithHeader('que/QueBase/getQueResult', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.dietary_advice = JSON.parse(res.data.dietary_advice)
            res.data.nutrients = JSON.parse(res.data.nutrients)
            res.data.performance = JSON.parse(res.data.performance)
            res.data.reduce_intake = JSON.parse(res.data.reduce_intake)
            res.data.reference = JSON.parse(res.data.reference)
            res.data.first_choose = JSON.parse(res.data.first_choose)
            res.data.combination = JSON.parse(res.data.combination)
            this.info = res.data
            this.$emit('copyUrl', getShareUrl(this.info.que_id))
          } else {
            this.$toast(res.msg)
          }
        })
    },
    bindMyCourse() {
      appApi.jumpMiniProgram({
        appId: 'gh_3da9370ac840',
        path: 'page/home/index'
      })
    },
    bindHandleGoods() {
      let url = this.info.first_choose.url
      if (this.$http._isApp() && url) {
        this.$betterwe.jumpWmStore(url)
      }
    },
    bindHandleGoodsGroup() {
      let url = this.info.combination.url
      if (this.$http._isApp() && url) {
        this.$betterwe.jumpWmStore(url)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  min-height: 100vh;
  background-color: #f7f7f7;

  .container {
    min-height: 60vh;
    position: relative;
    background-image: linear-gradient(
      180deg,
      rgba(169, 157, 251, 1) 0px,
      rgba(169, 157, 251, 0) 350px
    );
    padding: 56px 16px 30px;
    box-sizing: border-box;
  }

  .bg {
    position: absolute;
    right: 30px;
    top: 10px;
    width: 121px;
    height: 109px;
    object-fit: contain;
  }

  .c-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .c-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .title-icon {
      width: 26px;
      height: 26px;
      object-fit: contain;
      margin-right: 6px;
    }

    .title-text {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #27243c;
      line-height: 28px;
    }
  }

  .top {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .user-info {
      width: 100%;
      margin-top: -47px;
      text-align: center;
      margin-bottom: 10px;

      .avatar {
        margin: 0 auto;
        width: 54px;
        height: 54px;
        border: 2.5px solid #fff;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 6px;
        .avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 22px;
      }
    }

    .desc {
      font-size: 9px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(39, 36, 60, 0.6);
      line-height: 16px;
      padding-bottom: 12px;
      border-bottom: 1px dashed rgba(58, 55, 82, 0.12);
      margin-bottom: 7px;
    }

    .type-content {
      display: flex;
      align-items: center;
      justify-content: center;

      .type-image {
        width: 120px;
        height: 120px;
        object-fit: contain;
      }

      .type-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        // margin-right: 10px;

        .type-desc {
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(39, 36, 60, 0.8);
          line-height: 22px;
        }

        .type-text {
          position: relative;
          z-index: 0;
          font-size: 36px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #27243c;
          line-height: 50px;

          .line {
            position: absolute;
            z-index: -1;
            left: 0;
            bottom: 0;
            width: 187px;
            height: 10px;
            background: linear-gradient(
              270deg,
              rgba(159, 145, 254, 0) 0%,
              #9f91fe 100%
            );
            border-radius: 8px;
            opacity: 0.5;
          }
        }
      }
    }

    .dietitian-content {
      position: relative;
      padding: 13px 16px 16px;
      background: #fdf8eb;
      border-radius: 12px;
      margin-top: 13px;

      .d-dot {
        position: absolute;
        right: 16px;
        top: 16px;
        width: 40px;
        height: 40px;
        object-fit: contain;
      }

      .d-info {
        display: flex;
        align-items: center;
        margin-bottom: 13px;

        .d-avatar {
          width: 32px;
          height: 32px;
          object-fit: cover;
          border-radius: 4px;
          overflow: hidden;
          margin-right: 10px;
        }

        .d-right {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;

          .d-name {
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #27243c;
            line-height: 20px;
          }

          .d-tag-list {
            display: flex;
            align-items: center;

            .d-tag-item {
              padding: 0px 4px;
              font-size: 9px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #ffffff;
              line-height: 16px;
              background: #f9c478;
              border-radius: 2px;
              margin-right: 4px;
            }
          }
        }
      }

      .d-text {
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #bd885c;
        line-height: 20px;
      }
    }

    .dietitian-content::after {
      content: '';
      position: absolute;
      right: 100px;
      top: -13px;
      width: 0;
      height: 0;
      border-top: 13px solid transparent;
      border-bottom: 13px solid transparent;
      border-right: 18px solid #fdf8eb;
    }
  }

  .influence {
    .desc {
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(39, 36, 60, 0.45);
      line-height: 20px;
    }
  }

  .performance {
    .list {
      .item {
        color: rgba(39, 36, 60, 0.45);
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        line-height: 20px;

        .item-bold {
          color: rgba(39, 36, 60, 1);
        }
      }
    }
  }

  .suggest {
    .gray-content {
      padding: 20px 16px;
      background: #f6f7f9;
      border-radius: 12px;

      .gray-title {
        display: inline-block;
        position: relative;
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 21px;
        margin-bottom: 16px;
      }

      .gray-title::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 7px;
        background: linear-gradient(
          270deg,
          rgba(159, 145, 254, 0) 0%,
          #9f91fe 100%
        );
        border-radius: 8px;
        opacity: 0.5;
      }

      .gray-item {
        margin-bottom: 20px;
      }

      .gray-item:last-child {
        margin-bottom: 0px;
      }

      .suggest-list,
      .ele-list {
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(39, 36, 60, 0.45);
        line-height: 20px;

        .suggest-item,
        .ele-item {
          .item-title {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #27243c;
            line-height: 20px;
            margin-bottom: 5px;

            .item-num {
              display: inline-block;
              border-radius: 50%;
              width: 18px;
              height: 18px;
              text-align: center;
              line-height: 18px;
              background: linear-gradient(180deg, #fae39b 0%, #fac271 100%);
              font-size: 15px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #ffffff;
              margin-right: 8px;
            }
          }

          .item-bold {
            color: rgba(39, 36, 60, 1);
          }
        }

        .ele-item {
          margin-bottom: 12px;
        }

        .ele-item:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }
  .coach-recommend {
    .goods-list {
      .goods-item {
        margin-bottom: 16px;
        position: relative;
        .goods-image {
          width: 100%;
        }
      }
      .goods-item:last-child {
        margin-bottom: 0;
      }
    }
  }
  .literature {
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.4);
    line-height: 14px;

    .literature-item {
      margin-bottom: 8px;
    }
  }

  .course-container {
    padding-top: 34px;

    .course-box {
      position: relative;
      margin-bottom: 16px;
      width: 100%;

      .course-content {
        padding: 16px;
        box-sizing: border-box;
        border-radius: 6px;
        background: linear-gradient(
          180deg,
          rgb(240, 238, 254) 0%,
          rgb(242, 240, 255) 100%
        );
        position: relative;
        z-index: 1;

        .dot {
          width: 40px;
          height: 40px;
          position: absolute;
          left: 14px;
          top: 0;
          transform: translate(0%, -50%);
        }

        .c-flex {
          display: flex;
          align-items: flex-end;
          margin-bottom: 2px;

          .c-flex-left {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            font-size: 11px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #73689d;
            line-height: 20px;
          }

          .c-avatar {
            width: 40px;
            height: 40px;
            object-fit: cover;
            margin-left: 20px;
          }
        }

        .c-desc {
          font-size: 15px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #73689d;
          line-height: 24px;
        }
      }
    }

    .course-box::after {
      content: '';
      position: absolute;
      z-index: 0;
      width: 0px;
      height: 0px;
      right: 50px;
      bottom: -10px;
      border-left: 20px solid rgb(242, 240, 255);
      border-bottom: 10px solid transparent;
      border-top: 10px solid transparent;
    }

    .camp-list {
      .camp-item {
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px dashed rgba(58, 55, 82, 0.12);
        margin-bottom: 9px;

        .camp-title {
          text-align: center;
          position: relative;
          z-index: 1;
          padding-left: 8px;
          border-radius: 4px 3px 3px 4px;
          width: 90px;
          box-sizing: border-box;
          height: 20px;
          font-size: 11px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 20px;
          background: linear-gradient(
            180deg,
            #cdc4ff 0%,
            #9f91fe 80%,
            rgba(185, 174, 255, 1) 100%
          );
          margin-right: 10px;
        }

        .camp-title::after {
          content: '';
          position: absolute;
          z-index: -1;
          width: 14px;
          height: 14px;
          background: linear-gradient(
            135deg,
            #cdc4ff 0%,
            #9f91fe 80%,
            rgba(185, 174, 255, 1) 100%
          );
          right: 0;
          top: 50%;
          border-radius: 0px 4px 0px 0px;
          transform: translate(45%, -50%) rotate(45deg);
          transform-origin: center;
        }

        .camp-text {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 11px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #27243c;
          line-height: 20px;
        }
      }

      .camp-item:last-child {
        border-bottom: none;
        margin-bottom: 0px;
      }
    }

    .my-course {
      margin-top: 12px;
      height: 42px;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #e1dede;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      padding: 0px 16px;

      .text {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 18px;
        margin-right: 10px;
      }

      .icon {
        width: 26px;
        height: 26px;
        object-fit: contain;
        margin-right: 10px;
      }

      .iconfont {
        font-size: 20px;
        color: rgba(39, 36, 60, 0.5);
      }
    }

    .desc {
      text-align: center;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(39, 36, 60, 0.36);
      line-height: 18px;
    }
  }
}

.logo {
  height: 12px;
  margin: 20px auto 0px;
}

.share {
  font-size: 24px;
}
</style>
